import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/img/icon/deleteFilledAntDesignRed.svg'


const _hoisted_1 = {
  id: "city-form",
  class: "flex-col flex relative h-full overflow-x-hidden",
  style: {"overflow-y":"auto"}
}
const _hoisted_2 = { class: "title-form py-5 mb-6 flex items-center justify-between" }
const _hoisted_3 = { class: "font-bold" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-3 h-3",
  alt: "delete"
}, null, -1)
const _hoisted_5 = { class: "p-fluid" }
const _hoisted_6 = { class: "p-field mb-4" }
const _hoisted_7 = /*#__PURE__*/_createVNode("label", { for: "codeAgentType" }, "Kode Tipe Agen", -1)
const _hoisted_8 = {
  key: 0,
  class: "p-error"
}
const _hoisted_9 = { class: "p-field mb-4" }
const _hoisted_10 = /*#__PURE__*/_createVNode("label", { for: "nameAgentType" }, "Nama Tipe Agen", -1)
const _hoisted_11 = {
  key: 0,
  class: "p-error"
}
const _hoisted_12 = { class: "p-field mb-4" }
const _hoisted_13 = /*#__PURE__*/_createVNode("label", { for: "authorityGoods" }, "Wewenang Barang", -1)
const _hoisted_14 = {
  key: 0,
  class: "p-error"
}
const _hoisted_15 = {
  key: 0,
  class: "p-field"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("label", { for: "idActive" }, "Aktif", -1)
const _hoisted_17 = { class: "btn-action w-full mt-auto mb-5" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Kembali")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_MultiselectAsync = _resolveComponent("MultiselectAsync")
  const _component_InputSwitch = _resolveComponent("InputSwitch")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("h6", _hoisted_3, _toDisplayString(_ctx.title), 1),
      (_ctx.data && _ctx.route.meta.permission.delete)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: "background-red-lighten-5 p-3 rounded-md cursor-pointer",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.deleteData()))
          }, [
            _hoisted_4
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("form", {
      id: "form-type-agent",
      onSubmit: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.submitData(!_ctx.v$.$invalid)), ["prevent"]))
    }, [
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_InputText, {
            maxlength: "50",
            id: "codeAgentType",
            class: "input-primary mt-1 uppercase",
            name: "codeAgentType",
            modelValue: _ctx.v$.codeAgentType.$model,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.codeAgentType.$model = $event)),
            type: "text"
          }, null, 8, ["modelValue"]),
          ((_ctx.v$.codeAgentType.$invalid && _ctx.submitted) || _ctx.v$.codeAgentType.$pending.$response)
            ? (_openBlock(), _createBlock("small", _hoisted_8, _toDisplayString(_ctx.v$.codeAgentType.required.$message), 1))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_9, [
          _hoisted_10,
          _createVNode(_component_InputText, {
            maxlength: "100",
            id: "nameAgentType",
            class: "input-primary mt-1",
            type: "text",
            name: "nameAgentType",
            modelValue: _ctx.v$.nameAgentType.$model,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.v$.nameAgentType.$model = $event))
          }, null, 8, ["modelValue"]),
          ((_ctx.v$.nameAgentType.$invalid && _ctx.submitted) || _ctx.v$.nameAgentType.$pending.$response)
            ? (_openBlock(), _createBlock("small", _hoisted_11, _toDisplayString(_ctx.v$.nameAgentType.required.$message), 1))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_12, [
          _hoisted_13,
          _createVNode(_component_MultiselectAsync, {
            idInput: "aothority-item",
            endpoint: _ctx.endpointItemCategory,
            modelValue: _ctx.v$.authorityGoodsId.$model,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.v$.authorityGoodsId.$model = $event)),
            fieldLabel: "Nama",
            searchFields: ['name'],
            filters: [['isActive', '=', true]],
            placeholder: "Cari berdasarkan nama kategori barang ",
            class: "mt-1",
            mode: "tags"
          }, null, 8, ["endpoint", "modelValue"]),
          ((_ctx.v$.authorityGoodsId.$invalid && _ctx.submitted) || _ctx.v$.authorityGoodsId.$pending.$response)
            ? (_openBlock(), _createBlock("small", _hoisted_14, _toDisplayString(_ctx.v$.authorityGoodsId.required.$message), 1))
            : _createCommentVNode("", true)
        ]),
        (_ctx.data)
          ? (_openBlock(), _createBlock("div", _hoisted_15, [
              _hoisted_16,
              _createVNode("div", null, [
                _createVNode(_component_InputSwitch, {
                  id: "idActive",
                  class: "switch-og mt-1",
                  modelValue: _ctx.dataForm.isActive,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.dataForm.isActive = $event))
                }, null, 8, ["modelValue"])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ], 32),
    _createVNode("div", _hoisted_17, [
      _createVNode(_component_Button, {
        label: "Simpan",
        type: "submit",
        form: "form-type-agent",
        class: "font-semibold p-button-sm btn-primary px-10 mr-2"
      }),
      _createVNode(_component_Button, {
        class: "btn-secondary text-black p-button-sm px-10 py-1",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.closeSidebar()))
      }, {
        default: _withCtx(() => [
          _hoisted_18
        ]),
        _: 1
      })
    ])
  ]))
}